(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customHero-single"] && !Shopify.designMode) return;
  try {
    
  const desktopVideo = document.querySelector('.video-container-desktop .video-section');
  const desktopImage = document.querySelector('.imgOne.desktopOnly');
  const mobileImage = document.querySelector('.imgThreeMobile.mobileOnly');
  const mobileVideo =  document.querySelector('.video-container-mobile .video-section');
  
  function initVideoHandler(videoContainer) {
    const interval = setInterval(() => {
      videoContainer?.classList.add('show')
      clearInterval(interval);
  }, 300);
  }

  if ( window.innerWidth > 767 ){
      initVideoHandler(desktopVideo); 
  } else {
      initVideoHandler(mobileVideo);
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-returns"]) return;
  try {
    
  // Select the node that will be observed for mutations
  const targetNode = document.querySelector('.return-portal');
  const featured_image = document.querySelector('.return-portal__featured');

  // Options for the observer (which mutations to observe)
  const config = { childList: true, subtree: true };

  // Callback function to execute when mutations are observed
  const callback = function (mutationsList, observer) {
    for (let mutation of mutationsList) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            if (
              node.matches('.ReturnGO_Steps-module_stepsContainer') ||
              node.querySelector('.ReturnGO_Steps-module_stepsContainer')
            ) {
              console.log('.ReturnGO_Steps-module_stepsContainer');
              console.log(document.querySelector('.return-portal__featured'));
              // Perform your actions here
              document.querySelector('.return-portal__featured').style.display = 'none';
              document.querySelector('.return-portal__app').classList.add('return-portal__app--active');
            } else {
              if (!document.querySelector('.ReturnGO_Steps-module_stepsContainer')) {
                console.log('removed .ReturnGO_Steps-module_stepsContainer');
                document.querySelector('.return-portal__featured').style.display = 'block';
                document.querySelector('.return-portal__app').classList.remove('return-portal__app--active');
              }
            }
          }
        });
      }
    }
  };

  // Create an observer instance linked to the callback function
  const observer = new MutationObserver(callback);

  // Start observing the target node for configured mutations
  observer.observe(targetNode, config);

  } catch(e) { console.error(e); }
})();
})();
